import { IAccountDetailsDTO } from './accounts.dao';
import { IPaginationParams } from './shared.dto';
abstract class IAccountGroupsDAO {
    public abstract getAccountGroups(params: IPaginationParams): Promise<IAccountGroupsListDTOInternal>;
    public abstract createGroup(params: IAccountGroupCreateDTO): Promise<IAccountGroupDTO>;
    public abstract getAccountGroupById(params: { accountGroupId: number }): Promise<IAccountGroupDTO>;
    public abstract updateGroup(params: IAccountGroupEditDTO): Promise<IAccountGroupDTO>;
    public abstract deleteGroup(params: { accountGroupId: number }): Promise<void>;
}

interface IAccountGroupDTO {
    accountGroupId: number;
    name: string;
    description: string;
    accounts: IAccountDetailsDTO[];
}

type IAccountGroupCreateDTO = Omit<IAccountGroupDTO, 'accountGroupId'>;

interface IAccountGroupEditDTO extends Omit<IAccountGroupDTO, 'accounts' | 'accountGroupId'> {
    addedAccounts: number[];
    removedAccounts: number[];
}

interface IAccountGroupsListDTOInternal {
    content: IAccountGroupDTO[];
    totalElements: number;
}

export {
    IAccountGroupsListDTOInternal,
    IAccountGroupCreateDTO,
    IAccountGroupsDAO,
    IAccountGroupDTO,
    IAccountGroupEditDTO
};
